export const cardTypes = {
    1: 'ECOM_CARD_TYPE_1',
    2: 'ECOM_CARD_TYPE_2'
}